export enum ExtendedAttributeCategoryEnum {
    USER = 1,
    REQUEST_FIELD = 2,
    APPROVAL_FIELD = 3,
    COURSE_OFFERING = 4,
    COURSE_EXECUTION = 5,
}
